// Mega-Menu Dropdown
const mmListParent = document.getElementById('shopify-section-header');
const mmListItems = document.querySelectorAll('li span');
if (mmListItems){
  mmListItems.forEach(item => {
    if (item.textContent.includes('SHOP')) {
      item.classList.add('shop-now-link');
    } else if (item.textContent.includes('Shop')) {
      item.classList.add('shop-now-link');
    }
  });
}
// Mobile Drawer
const mobileListParent = document.getElementById('header-mobile-drawer');
const mobileListItems = document.querySelectorAll('li a');
if (mobileListItems){
  mobileListItems.forEach(item => {
    if (item.textContent.includes('SHOP')) {
      item.classList.add('shop-now-link');
    } else if (item.textContent.includes('Shop')) {
      item.classList.add('shop-now-link');
    }
  });
}